import { render, staticRenderFns } from "./SuggestionsSection.vue?vue&type=template&id=553e2bc8&scoped=true&"
import script from "./SuggestionsSection.vue?vue&type=script&lang=ts&"
export * from "./SuggestionsSection.vue?vue&type=script&lang=ts&"
import style0 from "./SuggestionsSection.vue?vue&type=style&index=0&id=553e2bc8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553e2bc8",
  null
  
)

export default component.exports